import React, { useState, createContext } from 'react';
import PropTypes from 'prop-types';

import Loading from '../components/Loading/Loading';

export const LoadingContext = createContext();

const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  return (
    <LoadingContext.Provider value={{
      setLoading
    }}
    >
      {children}
      {loading && <Loading show={loading} />}
    </LoadingContext.Provider>
  );
};

export default LoadingProvider;

LoadingProvider.propTypes = {
  children: PropTypes.element.isRequired
};

LoadingProvider.defaultProps = {};
